import { useEffect, useState, useRef } from "react";
import {
  Box,
  Grid,
  Button,
  Card,
  CardContent,
  Tooltip,
  IconButton,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@mui/material";
import { Edit, Delete, ContentCopy } from "@mui/icons-material";
import axios from "axios";
import CustomTable from "../../components/customTable/CustomTable";
import { createMRTColumnHelper } from "material-react-table";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { policyApi } from "../../app/slices/policySlice";
import JoditEditor from "jodit-react";
import CloseIcon from "@mui/icons-material/Close";
import axiosInstance from "../../utils/axiosInstance";
const Policy = () => {
  const [open, setOpen] = useState(false);
  const [fullContent, setfullContent] = useState(null);
  // console.log("fullContent: ", fullContent);

  // console.log("Open: ", open);

  const baseUrl = import.meta.env.VITE_BASE_URL;
  const token = localStorage.getItem("token");
  const headers = { Authorization: `Bearer ${token}` };
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(policyApi());
  }, [dispatch]);

  const sliceResponse = useSelector((state) => state.policy.policy.data);
  const stateLoading = useSelector((state) => state.policy.loading);
  const [submitLoading, setSubmitLoading] = useState(false);
  const editorRef = useRef(null);

  const [formData, setFormData] = useState({
    _id: null,
    type: "",
    content: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleEditorChange = (newContent) => {
    setFormData((prev) => ({
      ...prev,
      content: newContent,
    }));
  };

  const validateForm = () => {
    const { type, content } = formData;
    if (!type || !content.trim()) {
      Swal.fire({
        text: "Both Type and Content are required",
        icon: "warning",
        timer: 3000,
        showConfirmButton: false,
      });
      return false;
    }
    return true;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;

    setSubmitLoading(true);
    try {
      const response = await axiosInstance.post(
        `/policy/createAndUpdate`,
        formData,
        // { headers }
      );
      // const response = await axios.post(
      //     `${baseUrl}/policy/createAndUpdate`,
      //     formData,
      //     { headers }
      // );

      if (response.data.error === false) {
        Swal.fire({
          text: response.data?.message || "Policy saved successfully",
          icon: "success",
          timer: 3000,
          showConfirmButton: false,
        });
        setFormData({ _id: null, content: "", type: "" });
        dispatch(policyApi());
      } else {
        Swal.fire({
          text: response.data?.message || "Something went wrong!",
          icon: "error",
          timer: 3000,
          showConfirmButton: false,
        });
      }
    } catch (error) {
      console.error("API Error:", error);
      Swal.fire({
        text: "Something went wrong",
        icon: "error",
        timer: 3000,
        showConfirmButton: false,
      });
    } finally {
      setSubmitLoading(false);
    }
  };

  const handleEdit = (row) => {
    setFormData({
      _id: row._id,
      type: row.type,
      content: row.content,
    });
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await axiosInstance.delete(`/policy/destroy/${id}`);
          // const response = await axios.delete(`${baseUrl}/policy/destroy/${id}`, { headers });
          if (response.data.error === false) {
            toast.success(response.data.message || "Deleted successfully");
            dispatch(policyApi());
            setFormData({ _id: null, content: "", type: "" });
          } else {
            toast.error(response.data.message || "Delete failed");
          }
        } catch (error) {
          toast.error("Server error while deleting");
        }
      }
    });
  };

  const columnHelper = createMRTColumnHelper();

  const columns = [
    columnHelper.accessor("_id", {
      header: "ID",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?._id);
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?._id}>
            <IconButton onClick={handleCopy}>
              <ContentCopy />
            </IconButton>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("type", {
      header: "Type",
    }),
    columnHelper.accessor("content", {
      header: "Content",
      Cell: ({ cell }) => (
        <Button
          onClick={() => {
            setOpen(true);
            setfullContent(cell.row.original?.content || "");
          }}
          variant="contained"
        >
          {" "}
          View Content
        </Button>
      ),
    }),

    // columnHelper.accessor("content", {
    //     header: "Content",
    //     Cell: ({ cell }) => (

    //         <div
    //             dangerouslySetInnerHTML={{
    //                 __html: cell.row.original?.content || "",
    //             }}
    //         />
    //     ),
    // }),
    columnHelper.accessor("createdAt", {
      header: "Created At",
      Cell: (cell) => cell.row.original.createdAt.split("T")[0],
    }),
    columnHelper.accessor("updatedAt", {
      header: "Updated At",
      Cell: (cell) => cell.row.original.updatedAt.split("T")[0],
    }),
    columnHelper.display({
      id: "actions",
      header: "Actions",
      Cell: ({ row }) => (
        <>
          <Tooltip title="Edit">
            <IconButton
              onClick={() => handleEdit(row.original)}
              color="primary"
            >
              <Edit />
            </IconButton>
          </Tooltip>
          <Tooltip title="Delete">
            <IconButton
              onClick={() => handleDelete(row.original._id)}
              color="error"
            >
              <Delete />
            </IconButton>
          </Tooltip>
        </>
      ),
    }),
  ];

  return (
    <>
      <Card sx={{ mb: 4 }}>
        <CardContent>
          <Box component="form" onSubmit={(e) => e.preventDefault()}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <InputLabel>Type</InputLabel>
                  <Select
                    fullWidth
                    label="Type"
                    name="type"
                    value={formData.type}
                    onChange={handleChange}
                    required
                  >
                    <MenuItem value="terms">Terms</MenuItem>
                    <MenuItem value="refund">Refund</MenuItem>
                    <MenuItem value="privacy">Privacy</MenuItem>
                    <MenuItem value="shipping">Shipping</MenuItem>
                    <MenuItem value="aboutUs">About Us</MenuItem>
                    <MenuItem value="missionVision">Mission Vision</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <JoditEditor
                  ref={editorRef}
                  value={formData.content}
                  tabIndex={1}
                  onBlur={handleEditorChange}
                  config={{ readonly: false }}
                />
              </Grid>

              <Grid item xs={12}>
                <Button
                  fullWidth
                  variant="contained"
                  size="large"
                  disabled={submitLoading}
                  onClick={handleSubmit}
                  sx={{
                    float: "right",
                    p: { xs: 1, sm: 1.8 },
                    transition: "transform 0.5s ease-in-out",
                    "&:hover": {
                      transform: "scale(1.01)",
                    },
                  }}
                >
                  {submitLoading
                    ? "Submitting..."
                    : formData._id
                      ? "Update"
                      : "Create"}
                </Button>
              </Grid>
            </Grid>
          </Box>
        </CardContent>
      </Card>

      <CustomTable
        columns={columns}
        data={sliceResponse}
        loading={stateLoading}
        permissionKey="Policy"
      />
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          Full Content
          <Tooltip title="Close">
            <IconButton
              sx={{ float: "right" }}
              onClick={() => {
                setOpen(false);
              }}
              aria-label="delete"
              size="small"
            >
              <CloseIcon
                fontSize="inherit"
                color="error"
                sx={{ color: "red" }}
              />
            </IconButton>
          </Tooltip>
        </DialogTitle>
        <DialogContent dividers>
          <div dangerouslySetInnerHTML={{ __html: fullContent }} />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default Policy;
